export enum NavbarTypes {
  Primary = 'primary',
  Secondary = 'secondary',
  Transparent = 'transparent',
}

export type NavbarTransparentElement = HTMLElement | null;
